import React from 'react';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet-async';
import LoginSection, { LoginProps } from '../components/LoginSection';
import { useFlow } from '../utilities/useFlow';

interface LoginComponentProps extends LoginProps {}

function LoginComponent(props: LoginComponentProps): JSX.Element {
  const flow = useFlow();

  return (
    <>
      <Helmet>
        <title>{`Login | ${flow}`}</title>
        <meta name="description" content={`Log in to your ${flow} account to manage your storage, shipping, and removals orders.`} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="auth-page">
        <LoginSection {...props} />
      </div>
    </>
  );
}

export default withRouter(LoginComponent);
